export type LegacyLabelMap = Record<string, string | string[]>;

function isEnabledLegacyLabelValue(value: string | string[]): boolean {
  if (Array.isArray(value)) return value.includes('true');
  return value === 'true';
}

export function resolveAppliedLabels(labels?: string[], legacyLabelMap?: LegacyLabelMap): string[] {
  if (Array.isArray(labels) && labels.length > 0) return labels;
  if (!legacyLabelMap) return [];

  return Object.entries(legacyLabelMap)
    .filter(([, value]) => isEnabledLegacyLabelValue(value))
    .map(([key]) => key);
}

/**
 * Ensures the "labels" column is visible after adding labels to an interaction or conversation.
 */
export function ensureLabelsColumnSelected(scope: 'interaction' | 'conversation', defaultColumns: string[]): void {
  const key = scope === 'conversation' ? 'availableConversationColumns' : 'availableInteractionColumns';

  const stored = localStorage.getItem(key);
  const current: string[] = stored ? (JSON.parse(stored) as string[]) : defaultColumns;

  if (current.includes('labels')) return;

  const next = [...current, 'labels'];
  localStorage.setItem(key, JSON.stringify(next));
  window.dispatchEvent(new CustomEvent(`ls-update-${key}`, { detail: { key } }));
}
